import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './css/App.css';
import Login from './Login';
import EventGeneratorForm from './EventGeneratorForm';
import Results from './Results';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/api/eventgenerator" element={
          <ProtectedRoute>
            <EventGeneratorForm />
          </ProtectedRoute>
        } />
        <Route path="/api/eventgenerator/results" element={
          <ProtectedRoute>
            <Results />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
